/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AddInstrumentDenylistEntryRequest} from '@cash-web/protos/squareup/cash/janus/api/InstrumentDenylistProto.pb'
import {AddInstrumentDenylistEntryResponse} from '@cash-web/protos/squareup/cash/janus/api/InstrumentDenylistProto.pb'


export const addInstrumentDenylistEntry = (request: AddInstrumentDenylistEntryRequest, options?: CashRequestOptions) => post<AddInstrumentDenylistEntryRequest, AddInstrumentDenylistEntryResponse>("/2.0/cash/add-instrument-denylist-entry", request, {...options, rejectOnError: true })